import { IonPage, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent } from '@ionic/react'
import { Container, Paper, Typography, Divider, Box, Grid, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router';
import { baseUrl, config, getUser, requestID } from '../../common/utils';
import axios from 'axios';
import UpdateBankDetailsModal from './UpdateBankDetailsModal';

const Profile = () => {
  const [status, setStatus] = useState({ loading: false, error: false });
  const turnAround = async () => {
    // event.preventDefault();
    setStatus({ loading: true, error: false });
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
   

      const response = await axios.post(
        baseUrl() + `withdrawals/sendReminderToDebtors`,
        formData,
        config
      );
console.log(response)
      const { data } = response.data;
      console.log(data);

      setStatus({ loading: false, error: false });
    } catch (error) {
      console.error(error);
      setStatus({ loading: false, error: true });
    } finally {
      setStatus({ loading: false, error: false });
    }
  };
      // const {  firstName,
      //   lastName,
      //   middleName,
      //   dob,
      //   email,
      //   phone,
      //   residentialAddress,
      //   businessAddress,
      //   area,
      //   province,
      //   zone,
      //   lga,
      //   accountName,
      //   accountNumber,
      //   bankName,
      //   savingAmount,
      //   nextOfKin,
      //   nextOfKinAddress,
      //   nextOfKinPhone,
      //   nextOfKinRelationship,
      //   parish,
      //   pastorName,
      //   pastorPhone, } = getUser()?.userData
      
  const { name } = useParams<{ name: string }>();

type UserData = {
  firstName?: string;
  lastName?: string;
  middleName?: string;
  dob?: string;
  email?: string;
  phone?: string;

  residentialAddress?: string;
  businessAddress?: string;

  area?: string;
  province?: string;
  zone?: string;
  lga?: string;

  accountName?: string;
  accountNumber?: string;
  bankName?: string;
  registered_bankCode?: string;
  savingAmount?: string | number;

  nextOfKin?: string;
  nextOfKinAddress?: string;
  nextOfKinPhone?: string;
  nextOfKinRelationship?: string;

  parish?: string;
  pastorName?: string;
  pastorPhone?: string;
  bank_display_name?: string;
};

  // useEffect(()=>{
  //   turnAround()
  //   return ()=>{}
  // },[])

const [modalOpen, setModalOpen] = useState(false);
const [userData_r, setUserData_r] = useState<UserData>({});

  const [bankList, setBankList] = useState([]);

const {
  firstName,
  lastName,
  middleName,
  dob,
  email,
  phone,
  residentialAddress,
  businessAddress,
  accountName,
  accountNumber,
  bankName,
  bank_display_name,
  savingAmount,
} = userData_r || {};
  
  const getProfile_array = async () => {
    // try {
    setStatus({ loading: true, error: false });
    const formData = new FormData();
    formData.append("requestID", requestID());
 
   // console.log(formData);
    const response = await axios.post(
      baseUrl() + "users/getProfile_array",
      formData,
      config
    );
    console.log( response );
    setUserData_r(response.data.userData || {});
   // const data = await response.data.data;
   // setBankList(response.data.data.data || []);

    setStatus({ loading: false, error: false });
  };
  const getBankList = async () => {
    // try {
    setStatus({ loading: true, error: false });
    const formData = new FormData();
    formData.append("requestID", requestID());
 
   // console.log(formData);
    const response = await axios.post(
      baseUrl() + "warehouses/getbanklist",
      formData,
      config
    );
   // console.log( response.data.data.data );
   // const data = await response.data.data;
    setBankList(response.data.data.data || []);
    setStatus({ loading: false, error: false });
  };

   const [form, setForm] = useState([]);


   const getBankInfo = async () => {
 const formData = new FormData();
      formData.append("requestID", requestID());
  //    formData.append("user_id", String(userId));

      axios
        .post(`${baseUrl()}users/getBankDetails`, formData,config)
        .then((res) => {
          console.log(res.data);
          setForm(res.data);
        })
        .catch(() => alert('Failed to fetch bank details'));
    }


   

  //   // try { 

  useEffect(() => {
    getBankList();
  getProfile_array();
  getBankInfo();
   // getBranches();

  }, []);


  return (
    <IonPage>
      <UpdateBankDetailsModal
  open={modalOpen}
  //onClose={() => setModalOpen(false)}
    onClose={() => {
   
    getProfile_array(); // <-- Trigger after closing
     setModalOpen(false);
  }}
  userId={getUser()?.userData?.user_id}
    banklist={bankList}

/>


      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
    <Container maxWidth="lg" sx={{ mt: 4 }}>
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Profile Information
      </Typography>
      <Button color='primary' onClick={turnAround}> check</Button>
       <Button onClick={() => setModalOpen(true)}>Edit Bank Details</Button>

      <Button color='primary' onClick={turnAround}> Change Password</Button>

      <Divider sx={{ mb: 3 }} />

      {/* Personal Information */}
      <Box mb={3}>
        <Typography variant="h6" gutterBottom>
          Personal Information
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1">
              <strong>First Name:</strong> {firstName}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1">
              <strong>Last Name:</strong> {lastName}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1">
              <strong>Middle Name:</strong> {middleName}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1">
              <strong>Date of Birth:</strong> {dob}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1">
              <strong>Email:</strong> {email}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1">
              <strong>Phone:</strong> {phone}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Address Information */}
      <Box mb={3}>
        <Typography variant="h6" gutterBottom>
          Address Information
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Residential Address:</strong> {residentialAddress}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">
              <strong>Business Address:</strong> {businessAddress}
            </Typography>
          </Grid>
    
        </Grid>
      </Box>

      {/* Bank Information */}
      <Box mb={3}>
        <Typography variant="h6" gutterBottom>
          Bank Information
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1">
              <strong>Account Name:</strong> {accountName}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1">
              <strong>Account Number:</strong> {accountNumber}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1">
<strong>Bank Name:</strong> {form.name?.toUpperCase()}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1">
              <strong>Steward Limit :</strong> {savingAmount}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Next of Kin Information */}
     

      {/* Church Information */}
      
    </Paper>
  </Container>
  </IonContent>
  </IonPage>
  )
}

export default Profile